import { useEffect, useState } from "react";
import { END_POINT } from "../utils/End-points";

// Probe the server for reachability only once per app session. The hook is
// mounted by many components; without this guard each mount (doubled by
// StrictMode) fired its own /healthcheck request.
let hasProbed = false;

const useNetworkStatus = () => {
  const [isOnline, setOnline] = useState(navigator.onLine);

  useEffect(() => {
    const goOnline = () => setOnline(true);
    const goOffline = () => setOnline(false);

    if (!hasProbed) {
      hasProbed = true;
      fetch(END_POINT.BASE_URL + END_POINT.GET_HEALTH_CHECK, { mode: "no-cors" })
        .then(() => setOnline(true))
        .catch(() => setOnline(false));
    }

    window.addEventListener("online", goOnline);
    window.addEventListener("offline", goOffline);
    return () => {
      window.removeEventListener("online", goOnline);
      window.removeEventListener("offline", goOffline);
    };
  }, []);

  return { isOnline };
};

export default useNetworkStatus;
